import PropTypes from 'prop-types';
import SearchBox from '@wix/search-box-v2';
import createReactClass from 'create-react-class';
import {mixins, santaTypesDefinitions, utils} from 'santa-components';
import {measureComponent} from './measureComponent';
import {ACTION_TYPES} from './constants';
import {$skin, st, classes} from './SearchBox.st.css';
import {searchBoxBehaviors} from './behaviors/searchBoxBehaviors';
import {getDataAttributes} from '../../utils/attributesUtils';

const {
  skinBasedComp,
  runTimeCompData,
  validatableWithSyncMixin,
  textScaleMixin,
  inputFocusMixin,
} = mixins;

const getComponentSkins = () => ({
  'wixui.skins.SearchBox': $skin,
});

function getValueInRange(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function defaultNumberTo(value, defaultValue) {
  return isNaN(value) ? defaultValue : value;
}

const MIN_FONT_SIZE = 6;
const MAX_FONT_SIZE = 100;
const DEFAULT_MOBILE_FONT_SIZE = 14;

// https://github.com/wix-private/santa-langs/blob/master/src/main/resources/santa-editor/bundles/Site_Search
const TRANSLATIONS_NAMESPACE = 'Site_Search';

/**
 * @class components.searchBox
 * @extends {core.skinBasedComp}
 */
export const santaSearchBox = createReactClass({
  displayName: 'SearchBox',

  mixins: [
    skinBasedComp(getComponentSkins()),
    runTimeCompData,
    textScaleMixin(getComponentSkins()),
    validatableWithSyncMixin.validatableWithSync,
    inputFocusMixin,
  ],

  propTypes: {
    compProp: santaTypesDefinitions.Component.compProp.isRequired,
    compData: santaTypesDefinitions.Component.compData.isRequired,
    getTranslationAllKeys:
      santaTypesDefinitions.Translations.getTranslationAllKeys,
    componentPreviewState:
      santaTypesDefinitions.RenderFlags.componentPreviewState,
    styleId: santaTypesDefinitions.Component.styleId,
    style: santaTypesDefinitions.Component.style,
    shouldResetComponent:
      santaTypesDefinitions.RenderFlags.shouldResetComponent,
    value: PropTypes.string,
    scale: santaTypesDefinitions.Component.scale,
    isMobileView: santaTypesDefinitions.isMobileView,
    previewTooltipCallback:
      santaTypesDefinitions.RenderRealtimeConfig.previewTooltipCallback,
    userLanguage:
      santaTypesDefinitions.WixUserSantaTypes.userLanguage.isRequired,
  },

  statics: {
    getComponentSkins,
    behaviors: {
      ...validatableWithSyncMixin.VALIDATABLE_WITH_SYNC_BEHAVIORS,
      ...inputFocusMixin.INPUT_FOCUS_BEHAVIORS,
      ...searchBoxBehaviors,
    },
  },

  sizes: null,
  searchBoxRef: null,

  getInitialState() {
    return validatableWithSyncMixin.getPublicState();
  },

  componentDidUpdate(prevProps) {
    if (
      this.props.shouldResetComponent &&
      prevProps.shouldResetComponent !== this.props.shouldResetComponent
    ) {
      this.updateData({value: ''});
      this.closeSuggestions();
    }
  },

  focus() {
    if (this.searchBoxRef) {
      this.searchBoxRef.focus();
    }
  },

  blur() {
    if (this.searchBoxRef) {
      this.searchBoxRef.blur();
    }
  },

  createTranslationFunction() {
    const allKeys = this.props.getTranslationAllKeys(TRANSLATIONS_NAMESPACE, this.props.userLanguage);
    return key => allKeys[key];
  },

  handleSearchBoxRef(ref) {
    this.searchBoxRef = ref;
  },

  handleChange(e) {
    this.setSearchValue(e.target.value);
  },

  handleInput(e) {
    this.handleAction(ACTION_TYPES.ON_INPUT, {
      value: e.target.value,
    });
  },

  handleOnClear() {
    this.setSearchValue('');
    this.handleAction(ACTION_TYPES.ON_CLEAR);
  },

  handleSubmit() {
    this.handleAction(ACTION_TYPES.ON_SUBMIT);
  },

  handleFocus() {
    this.showDemoContentPopup();
    this.handleAction(ACTION_TYPES.ON_FOCUS);
  },

  handleBlur() {
    this.handleAction(ACTION_TYPES.ON_BLUR);
  },

  handleSuggestionSelect(suggestion, params) {
    this.handleAction(ACTION_TYPES.ON_SUGGESTION_SELECT, {
      ...suggestion,
      ...params,
    });
  },

  handleSuggestionGroupSelect(data) {
    this.handleAction(ACTION_TYPES.ON_SUGGESTION_GROUP_SELECT, data);
  },

  handleOnSuggestionsFooterClick(data) {
    this.handleAction(ACTION_TYPES.ON_SUGGESTIONS_FOOTER_CLICK, data);
  },

  showDemoContentPopup() {
    if (
      this.searchBoxRef &&
      this.isSuggestionEnabled() &&
      this.suggestionsAreNotEmpty()
    ) {
      this.props.previewTooltipCallback(
        this.searchBoxRef.formRef.getBoundingClientRect(),
        'PREVIEW_TOOLTIP_GOTO_LIVE_SITE',
      );
    }
  },

  openSuggestions() {
    if (this.searchBoxRef) {
      this.searchBoxRef.openSuggestions();
    }
  },

  closeSuggestions() {
    if (this.searchBoxRef) {
      this.searchBoxRef.closeSuggestions();
    }
  },

  getSelectionStart() {
    if (this.searchBoxRef) {
      return this.searchBoxRef.getSelectionStart();
    }

    return null;
  },

  getSelectionEnd() {
    if (this.searchBoxRef) {
      return this.searchBoxRef.getSelectionEnd();
    }

    return null;
  },

  measureComponent(node) {
    const sizes = measureComponent(node, {
      text: `${(this.props.compData.placeholder || 'Search').slice(0, 3)}...`,
      isCollapsed: this.props.compProp.isExpandable,
      sizes: this.sizes,
      shouldDecreaseHeight: !!this.props.componentPreviewState,
      shouldDecreaseWidth: true,
    });

    this.sizes = sizes;

    /**
     * width & height for boundaries
     * minWidth & minHeight are restrictions
     */
    return [{type: 'css', node, changes: sizes}];
  },

  setSearchValue(value) {
    const nextState = {
      value,
    };

    this.updateData(nextState);
    this.handleAction(ACTION_TYPES.ON_CHANGE, nextState);
  },

  getMobileFontSize() {
    if (!this.props.isMobileView) {
      return null;
    }

    const fontSize = parseInt(this.getFontSize('inputFont').fontSize, 10);

    return `${getValueInRange(
      defaultNumberTo(fontSize, DEFAULT_MOBILE_FONT_SIZE),
      MIN_FONT_SIZE,
      MAX_FONT_SIZE,
    )}px`;
  },

  isSuggestionEnabled() {
    return this.props.compData.suggestionsEnabled;
  },

  suggestionsAreNotEmpty() {
    return SearchBox.suggestionsAreNotEmpty(this.props.compData.suggestions);
  },

  shouldForceContentElementVisibility() {
    return this.isSuggestionEnabled() && this.suggestionsAreNotEmpty() ?
      !!this.props.componentPreviewState :
      false;
  },

  getSkinProperties() {
    const dataAttr = getDataAttributes(this.props);
    const searchBoxProps = {
      ...dataAttr,
      style: this.props.style,
      // NOTE: this fontSize needs only for mobile scale up/down GFPP buttons
      fontSize: this.getMobileFontSize(),
      styleId: this.props.styleId,
      value: this.props.compData.value,
      onChange: this.handleChange,
      onInput: this.handleInput,
      onClear: this.handleOnClear,
      onSubmit: this.handleSubmit,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      placeholder: this.props.compData.placeholder,
      disabled: this.props.compProp.isDisabled,
      iconAlignment: this.props.compProp.iconAlignment,
      textAlignment: this.props.compProp.textAlignment,
      textSpacing:
        this.props.compProp.textAlignment === 'left' ?
          this.props.compProp.textSpacing :
          0,
      iconSpacing: this.props.compProp.iconSpacing,
      withIcon: this.props.compProp.layout === 'icon',
      withButton: this.props.compProp.layout === 'button',
      previewState: this.props.componentPreviewState,
      suggestions: this.isSuggestionEnabled() ?
        this.props.compData.suggestions :
        null,

      onSuggestionSelect: this.handleSuggestionSelect,
      onSuggestionGroupSelect: this.handleSuggestionGroupSelect,
      onSuggestionsFooterClick: this.handleOnSuggestionsFooterClick,

      forceContentElementVisibility: this.shouldForceContentElementVisibility(
        this.props,
      ),

      isExpandable: this.props.compProp.isExpandable,
      expandedWidth: this.props.compProp.expandedWidth,
      expandedDirection: this.props.compProp.expandedDirection,
      ref: this.handleSearchBoxRef,
      className: st(classes.root, this.props.styleId),

      /**
       * backward-compatibility methods
       */
      onSuggestionClick: this.handleSuggestionSelect,
      onSuggestionShowAllClick: this.handleSuggestionGroupSelect,
      onSuggestionSearchAllClick: this.handleOnSuggestionsFooterClick,
      translate: this.createTranslationFunction(),
    };

    return {
      '': {
        children: [utils.createReactElement(SearchBox, searchBoxProps)],
      },
    };
  },
});
